import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { getCorrectEntityIdForActions } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import { requestFailed } from '../../../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../../../codegen/Localize';
import { IDataSourceDetailInfo } from '../../../../datasource/models/IDataSourceInfo';
import { ContentDraftStatus } from '../../../../drafts/serverApi/types/ContentDraft';
import { FlowDetailInfo } from '../../../../flow/models/FlowInfo';
import { IWorkbookDetailInfo } from '../../../../workbook/models/IWorkbookInfo';
import { DownloadAction } from '../../../actions/download/DownloadAction';
import { IContentInfo } from '../../../models/IContentInfo';
import { DownloadActions } from '../../../services/download/DownloadActions';

export function* processDownload(action: DownloadAction): SagaIterator {
  try {
    // TODO (fix someday): Hack because getDatasource API called in the download function takes a data connection id
    const entityId = yield call(getCorrectEntityIdForActions, action.item.contentType, action.item.id);
    yield call(downloadContent, { ...action.item, id: entityId });
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function downloadContent(
  item: IContentInfo
): Promise<IWorkbookDetailInfo | IDataSourceDetailInfo | FlowDetailInfo> {
  if (item.contentType === 'workbook') {
    return DownloadActions.downloadWorkbook(item);
  } else if (item.contentType === 'datasource') {
    return DownloadActions.downloadDatasource(item);
  } else if (item.contentType === 'flow'&& item.draftStatus === ContentDraftStatus.unpublished) {
    return DownloadActions.downloadFlowDraft(item);
  } else if (item.contentType === 'flow') {
    return DownloadActions.downloadFlow(item);
  }
}
